import classnames from 'classnames';
import { type ReactNode, forwardRef } from 'react';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';

type ControlButtonProps = {
  iconName?: string;
  onClick?: () => void;
  children?: ReactNode;
  title?: string;
  disabled?: boolean;
  className?: string;
};

export default forwardRef(function ControlButton(
  { iconName, onClick, children, title, disabled = false, className = '' }: ControlButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      {...(!disabled && onClickGenerator(() => onClick?.()))}
      className={classnames('control-button', className, {
        'control-button-disabled': disabled,
      })}
      title={title}
    >
      {iconName ? <i className={`fas fa-${iconName}`} /> : null}
      {children}
    </div>
  );
});
